function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26.003 26.25"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5.728 14.896-4.152 3.22a12.51 12.51 0 0 1 0-11.226A12.5 12.5 0 0 1 12.746 0a12.01 12.01 0 0 1 8.364 3.252l-3.569 3.57a6.8 6.8 0 0 0-4.795-1.875c-3.26 0-6.03 2.2-7.018 5.162a7.5 7.5 0 0 0 0 4.787",
    style: {
      fill: "#4285f4"
    },
    transform: "translate(1.003 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.913 14.496a6.24 6.24 0 0 1 0-3.987l.03-.089q.637-1.833 2.193-3.004 1.621-1.219 3.63-1.219a5.54 5.54 0 0 1 3.913 1.529l.883.842 5.344-5.344-.94-.883a13.25 13.25 0 0 0-9.22-3.59A13.75 13.75 0 0 0 .46 6.328l-.462.92.032.024a13.76 13.76 0 0 0 .43 11.403l.682 1.359 6.057-4.697zM1.576 6.89a12.51 12.51 0 0 0 0 11.226l1.01-.783 3.142-2.437a7.5 7.5 0 0 1 0-4.786v-.001c.988-2.962 3.758-5.162 7.018-5.162a6.8 6.8 0 0 1 4.795 1.874l2.685-2.684.884-.885A12.018 12.018 0 0 0 12.746 0a12.5 12.5 0 0 0-11.17 6.89",
    style: {
      fill: "#fff",
      opacity: 1
    },
    transform: "translate(1.003 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.757 12.788c0-.85-.07-1.704-.216-2.54H12.75v4.814h6.751a5.79 5.79 0 0 1-2.498 3.798v3.123h4.028c2.365-2.177 3.725-5.392 3.725-9.195",
    style: {
      fill: "#4285f4"
    },
    transform: "translate(1.003 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 25c3.371 0 6.214-1.106 8.286-3.017l-4.028-3.123c-1.121.762-2.568 1.194-4.253 1.194-3.262 0-6.027-2.2-7.019-5.158H1.58v3.22A12.5 12.5 0 0 0 12.75 25",
    style: {
      fill: "#34a853"
    },
    transform: "translate(1.003 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.732 14.896a7.5 7.5 0 0 1 0-4.786V6.89H1.58a12.51 12.51 0 0 0 0 11.226z",
    style: {
      fill: "#fbbc04"
    },
    transform: "translate(1.003 1.25)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.75 4.948a6.8 6.8 0 0 1 4.795 1.874l3.569-3.57A12.01 12.01 0 0 0 12.75.002 12.5 12.5 0 0 0 1.58 6.89l4.152 3.22c.987-2.963 3.757-5.163 7.018-5.163",
    style: {
      fill: "#ea4335"
    },
    transform: "translate(1.003 1.25)"
  }));
};
export default SvgGoogle;